import FetchStatusRepository from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import MailFooter            from "../../../../domain/mail/setting/MailFooter";
import MailReplyTo              from "../../../../domain/mail/setting/MailReplyTo";
import MailSetting           from "../../../../domain/mail/setting/MailSetting";
import MailSettingRepository from "../../../../domain/mail/setting/MailSettingRepository";
import FetchStatusDataSource from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailSettingDataSource from "../../../../infrastructure/datasource/mail/setting/MailSettingDataSource";
import NotifyDataSource      from "../../../../infrastructure/datasource/notify/NotifyDataSource";

class GetMailSetting {
  private readonly mailSettingRepository: MailSettingRepository = new MailSettingDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.mailSettingRepository.findBy();
      this.mailSettingRepository.setMailSetting(new MailSetting(
        new MailReplyTo(response.data.replyTo),
        new MailFooter(response.data.footer)
      ));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetMailSetting;
